import script from "./ServicosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicosPage.vue?vue&type=script&setup=true&lang=js"

import "./ServicosPage.vue?vue&type=style&index=0&id=4f7d8e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7d8e24"]])

export default __exports__